export class User {
    email :string;
    password : string;
    confirmPassword : string;
    phoneNumber : string;
    address : string;
    userType : string;
    fullName : string;
    vendorCode : string;
    type : string;
    isActive : boolean;
    createdBy : string;
    createdOn : string;
    updatedBy : string;
    updatedOn : string;
    registerCode : string;
    error : string;
    availableLimit : number;
    coCode : string;
    employeeId : string;
    officeLocation : string;
    emailUnavail : boolean;
}

